import {NgTableParams} from 'ng-table';
import nxModule from 'nxModule';
import ReportService from 'report/ReportService';
import {HttpService} from 'shared/utils/httpService';
import {PageRequest, PageResult} from 'tools/HttpTypes';
import templateUrl from './batch-remittance-history.template.html';

export interface BatchRemittanceHistoryRow {
  id : number,
  fileId: number,
  fileName: string,
  uploadedOn: string,
  applicablePeriod: string,
  officialReceipt: string,
  remittanceMethod: string,
  status: string,
  remarks: string,
  errorMessage: string,
  rowCount: number,
  processedCount: number,
  failedCount: number
}

export class BatchRemittanceHistoryComponent {

  private batchRemittanceHistory? : NgTableParams<BatchRemittanceHistoryRow>;
  private totalRowCount : number;
  private reportService : ReportService;
  private passDownloading : number[] = [];
  private failDownloading : number[] = [];

  constructor(private http: HttpService) {
    this.totalRowCount = 0;
    this.reportService = new ReportService();
  }

  async $onInit(): Promise<void> {
    this.batchRemittanceHistory = new NgTableParams({
      page: 1,
      count: 20
    }, {
      counts: [],
      total: 0,
      paginationMinBlocks: 3,
      paginationMaxBlocks: 8,
      getData: async (params: NgTableParams<BatchRemittanceHistoryRow>): Promise<BatchRemittanceHistoryRow[]> => {
        const request : PageRequest = {
          pageNo: params.page() - 1,
          pageSize: params.count()
        };
        const response = <PageResult<BatchRemittanceHistoryRow>> await this.http.get(`/remittance/history?pageNo=${request.pageNo}&pageSize=${request.pageSize}`).toPromise();
        this.totalRowCount = response.totalCount;
        params.total(this.totalRowCount);
        return response.result;
      }
    });
  }

  async downloadPassReport(batchId: number): Promise<void> {
    if(!this.passDownloading.includes(batchId)) {
      //Only allow 1 download request per button action
      this.passDownloading.push(batchId)
      await this.reportService.downloadFileReport({
        reportName: 'Remittance Transaction Report - Pass',
        parameters: {batchId: batchId}
      });
      this.passDownloading.splice(this.passDownloading.indexOf(batchId), 1)
    }
  }

  async downloadFailReport(batchId: number): Promise<void> {
    if(!this.failDownloading.includes(batchId)) {
      //Only allow 1 download request per button action
      this.failDownloading.push(batchId)
      await this.reportService.downloadFileReport({
        reportName: 'Remittance Transaction Report - Fail',
        parameters: {batchId: batchId}
      });
      this.failDownloading.splice(this.failDownloading.indexOf(batchId), 1)
    }
  }
}

nxModule.component('batchRemittanceHistory', {
  templateUrl: templateUrl,
  controller: BatchRemittanceHistoryComponent
});
